import { Device } from '@era/gateway-sdk';
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export function selectUnenrolledDeviceId(device: Device) {
  return device.identifier;
}

export const adapter: EntityAdapter<Device> = createEntityAdapter<Device>({
  selectId: selectUnenrolledDeviceId,
});

export type UnenrolledDeviceState = EntityState<Device>;

export const initialState: UnenrolledDeviceState = adapter.getInitialState();
